import React, { useContext, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { DynamicModuleLoader } from 'redux-dynamic-modules-react';
import getRootModule from 'RootModule';
import getCreditNotesMassiveUploadModule from '../getCreditNotesMassiveUploadModule';
import { layoutContext } from 'context';
import { useHistory } from 'react-router-dom';
import { Form } from 'antd';
import { UploadExcelButton, ActionButtonsExcelUpload } from 'common/MassiveUploads/components';
import MassiveUploadTable from '../components/MassiveUploadTable';
import { triggerModalForDuplicates } from 'common/MassiveUploads/utils';
//cambiar sagas
import {
  CreditNotesMassiveUploadSetAllowUpload,
  CreditNotesMassiveUploadRequestVerify,
  CreditNotesMassiveUploadRequestUpload,
  CreditNotesMassiveUploadClearUpload,
  CreditNotesMassiveUploadClearVerify,
  CreditNotesMassiveUploadClearAllowUpload,
  validateElementsRequest,
  validateElementsClean,
} from '../redux-saga/actions';

const CreditNoteMassiveUpload = (props) => {
  const {
    CreditNotesMassiveUploadSetAllowUpload: setAllowUpload,
    CreditNotesMassiveUploadRequestVerify: requestVerify,
    CreditNotesMassiveUploadRequestUpload: requestUpload,
    CreditNotesMassiveUploadClearUpload: clearUpload,
    CreditNotesMassiveUploadClearVerify: clearVerify,
    CreditNotesMassiveUploadClearAllowUpload: clearAllowUpload,
    allowUpload,
    verify,
    validateElementsRequest: validateElements,
    validateElementsClean: cleanElementsValidation,
  } = props;

  const history = useHistory();
  const [form] = Form.useForm();
  const { onChangeActiveComponent } = useContext(layoutContext);
  const [fileString, setFileString] = useState('');
  const correct = verify?.correct;
  const entriesList = verify?.objectList;
  const totalDuplicatedEntries = verify?.replaced?.length;
  const allCorrectMessage = verify?.allCorrectMessage;

  useEffect(() => {
    clearAllowUpload();
    validateElements({ history });
    return () => {
      clearAllowUpload();
      cleanElementsValidation();
      clearUpload();
      clearVerify();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    onChangeActiveComponent('activo');
    if (correct > 0) {
      setAllowUpload(true);
    } else {
      setAllowUpload(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [correct]);

  function customRequest({ file }) {
    requestVerify({ file, setFileString });
  }
  function requestReplace() {
    requestUpload({ history, fileString, overwrite: false });
  }
  function requestKeep() {
    requestUpload({ history, fileString, overwrite: false });
  }
  function onSubmit() {
    if (totalDuplicatedEntries > 0) {
      triggerModalForDuplicates(totalDuplicatedEntries, requestReplace, requestKeep, 'crédito');
      return;
    }

    requestReplace();
  }
  function onCancel() {
    history.push(`/account-status/base-information`);
  }

  return (
    <Form form={form}>
      <UploadExcelButton customRequest={customRequest} />
      <MassiveUploadTable data={entriesList} allCorrectMessage={allCorrectMessage} />
      <ActionButtonsExcelUpload
        onSubmit={onSubmit}
        onCancel={onCancel}
        disabled={!allowUpload}
        buttons={['cancel', 'submit']}
      />
    </Form>
  );
};

const mapStateToProps = (state) => {
  return {
    allowUpload: state?.Dynamic_MASSIVE_UPLOAD?.allowUpload,
    verify: state?.Dynamic_MASSIVE_UPLOAD?.verify,
  };
};

const ConnectedCreditNotesMassiveUpload = connect(mapStateToProps, {
  CreditNotesMassiveUploadSetAllowUpload,
  CreditNotesMassiveUploadRequestVerify,
  CreditNotesMassiveUploadRequestUpload,
  CreditNotesMassiveUploadClearUpload,
  CreditNotesMassiveUploadClearVerify,
  CreditNotesMassiveUploadClearAllowUpload,
  validateElementsRequest,
  validateElementsClean,
})(CreditNoteMassiveUpload);

const CreditNotesMassiveUpload = () => {
  return (
    <DynamicModuleLoader modules={[getRootModule(), getCreditNotesMassiveUploadModule()]}>
      <ConnectedCreditNotesMassiveUpload />
    </DynamicModuleLoader>
  );
};
export default CreditNotesMassiveUpload;
